import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a32ceaa"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a32ceaa')) {
      api.createRecord('1a32ceaa', component.options)
    } else {
      api.reload('1a32ceaa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1a32ceaa", function () {
      api.rerender('1a32ceaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/basic-layout/header-setting/index.vue"
export default component.exports